import {
  FETCH_EVENT_START,
  FETCH_EVENT_SUCCESS,
  FETCH_EVENT_ERROR,

  UPDATE_EVENT_START,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_ERROR,

  UPDATE_EVENT_SETTINGS_START,
  UPDATE_EVENT_SETTINGS_SUCCESS,
  UPDATE_EVENT_SETTINGS_ERROR,

  CLEAR_EVENT,

  FETCH_TICKET_LIST_START,
  FETCH_TICKET_LIST_SUCCESS,
  FETCH_TICKET_LIST_ERROR,

  FETCH_TICKET_START,
  FETCH_TICKET_SUCCESS,
  FETCH_TICKET_ERROR,

  SAVE_TICKET_START,
  SAVE_TICKET_SUCCESS,
  SAVE_TICKET_ERROR,

  UPDATE_TICKET_START,
  UPDATE_TICKET_SUCCESS,
  UPDATE_TICKET_ERROR,

  DELETE_TICKET_START,
  DELETE_TICKET_SUCCESS,
  DELETE_TICKET_ERROR,

  CLEAR_TICKET,

  SAVE_TICKET_SELECTION,
  CLEAR_TICKET_SELECTION,

  SAVE_PURCHASE_INFORMATION,
  CLEAR_PURCHASE_INFORMATION,

  PURCHASE_TICKET_START,
  PURCHASE_TICKET_SUCCESS,
  PURCHASE_TICKET_DECLINED,
  PURCHASE_TICKET_ERROR,

  CANCEL_PURCHASE,
  CLEAR_PURCHASE,

  FETCH_PURCHASED_TICKET_LIST_START,
  FETCH_PURCHASED_TICKET_LIST_SUCCESS,
  FETCH_PURCHASED_TICKET_LIST_ERROR,

  CLEAR_PURCHASED_LIST,

  FETCH_PURCHASED_TICKET_START,
  FETCH_PURCHASED_TICKET_SUCCESS,
  FETCH_PURCHASED_TICKET_ERROR,

  UPDATE_PURCHASED_TICKET_START,
  UPDATE_PURCHASED_TICKET_SUCCESS,
  UPDATE_PURCHASED_TICKET_ERROR,

  ATTEND_EVENT_START,
  ATTEND_EVENT_SUCCESS,
  ATTEND_EVENT_ERROR,

  FETCH_TICKET_RESERVE_START,
  FETCH_TICKET_RESERVE_SUCCESS,
  FETCH_TICKET_RESERVE_ERROR,

  CREATE_TICKET_RESERVE_START,
  CREATE_TICKET_RESERVE_SUCCESS,
  CREATE_TICKET_RESERVE_ERROR,

  CLEAR_TICKET_RESERVE,

  PURCHASE_OFFLINE_TICKET_START,
  PURCHASE_OFFLINE_TICKET_SUCCESS,
  PURCHASE_OFFLINE_TICKET_ERROR
} from './eventActions';

import {
  TICKETS_SALE_WIZARD_DETAILS,
  TICKETS_SALE_WIZARD_PAYMENT,
  TICKETS_SALE_WIZARD_CONFIRMATION
} from './eventUtils';

export const initialState = {
  event: {},
  tickets: {},
  reserve: null,
  ticket: {},
  purchasedTickets: {},
  purchasedTicket: {},
  ticketSelection: null,
  purchaseInformation: null,
  checkout: null,
  ticketsSaleWizardState: null,
  // Progress
  isFetchEventInProgress: false,
  isUpdateEventInProgress: false,
  isUpdateEventSettingsInProgress: false,
  isFetchTicketListInProgress: false,
  isFetchTicketInprogress: false,
  isSaveTicketInProgress: false,
  isUpdateTicketInProgress: false,
  isDeleteTicketInProgress: false,
  isPurchaseTicketInProgress: null,
  isFetchPurchsedTicketListInProgress: false,
  isFetchPurchasedTicketInProgress: false,
  isUpdatePurchasedTicketInProgress: false,
  isAttendEventInProgress: false,
  isFetchTicketReserveInProgress: false,
  isCreateTicketReserveInProgress: false,
  isPurchaseOfflineTicketInProgress: null,
};

export default function eventReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EVENT_START:
      return {
        ...state,
        isFetchEventInProgress: true
      };
    case FETCH_EVENT_SUCCESS:
      return {
        ...state,
        isFetchEventInProgress: false,
        event: action.payload
      };
    case FETCH_EVENT_ERROR:
      return {
        ...state,
        isFetchEventInProgress: false,
        event: initialState.event
      };

    case UPDATE_EVENT_START:
      return {
        ...state,
        isUpdateEventInProgress: true
      };
    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        isUpdateEventInProgress: false
      };
    case UPDATE_EVENT_ERROR:
      return {
        ...state,
        isUpdateEventInProgress: false
      };

    case UPDATE_EVENT_SETTINGS_START:
      return {
        ...state,
        isUpdateEventSettingsInProgress: true
      };
    case UPDATE_EVENT_SETTINGS_SUCCESS:
      return {
        ...state,
        isUpdateEventSettingsInProgress: false
      };
    case UPDATE_EVENT_SETTINGS_ERROR:
      return {
        ...state,
        isUpdateEventSettingsInProgress: false
      };

    case CLEAR_EVENT:
      return {
        ...state,
        event: initialState.event
      };

    case FETCH_TICKET_LIST_START:
      return {
        ...state,
        isFetchTicketListInProgress: true
      };
    case FETCH_TICKET_LIST_SUCCESS:
      return {
        ...state,
        isFetchTicketListInProgress: false,
        tickets: action.payload
      };
    case FETCH_TICKET_LIST_ERROR:
      return {
        ...state,
        isFetchTicketListInProgress: false,
        tickets: initialState.tickets
      };

    case FETCH_TICKET_START:
      return {
        ...state,
        isFetchTicketInprogress: true
      };
    case FETCH_TICKET_SUCCESS:
      return {
        ...state,
        isFetchTicketInprogress: false,
        ticket: action.payload
      };
    case FETCH_TICKET_ERROR:
      return {
        ...state,
        isFetchTicketInprogress: false,
        ticket: initialState.ticket
      };

    case SAVE_TICKET_START:
      return {
        ...state,
        isSaveTicketInProgress: true
      };
    case SAVE_TICKET_SUCCESS:
      return {
        ...state,
        isSaveTicketInProgress: false,
      };
    case SAVE_TICKET_ERROR:
      return {
        ...state,
        isSaveTicketInProgress: false,
      };

    case UPDATE_TICKET_START:
      return {
        ...state,
        isUpdateTicketInProgress: true
      };
    case UPDATE_TICKET_SUCCESS:
      return {
        ...state,
        isUpdateTicketInProgress: false,
      };
    case UPDATE_TICKET_ERROR:
      return {
        ...state,
        isUpdateTicketInProgress: false,
      };

    case DELETE_TICKET_START:
      return {
        ...state,
        isDeleteTicketInProgress: true
      };
    case DELETE_TICKET_SUCCESS:
      return {
        ...state,
        isDeleteTicketInProgress: false,
      };
    case DELETE_TICKET_ERROR:
      return {
        ...state,
        isDeleteTicketInProgress: false,
      };

    case CLEAR_TICKET:
      return {
        ...state,
        ticket: initialState.ticket
      };

    case SAVE_TICKET_SELECTION:
      return {
        ...state,
        ticketSelection: action.payload
      };

    case CLEAR_TICKET_SELECTION:
      return {
        ...state,
        ticketSelection: initialState.ticketSelection
      };

    case SAVE_PURCHASE_INFORMATION:
      return {
        ...state,
        purchaseInformation: action.payload
      };

    case CLEAR_PURCHASE_INFORMATION:
      return {
        ...state,
        purchaseInformation: initialState.purchaseInformation
      };

    case PURCHASE_TICKET_START:
      return {
        ...state,
        isPurchaseTicketInProgress: true
      };
    case PURCHASE_TICKET_SUCCESS:
    case PURCHASE_TICKET_DECLINED:
      return {
        ...state,
        checkout: action.payload,
        ticketsSaleWizardState: TICKETS_SALE_WIZARD_CONFIRMATION,
        isPurchaseTicketInProgress: initialState.isPurchaseTicketInProgress
      };
    case CANCEL_PURCHASE:
      return {
        ...state,
        ticketsSaleWizardState: TICKETS_SALE_WIZARD_CONFIRMATION,
        isPurchaseTicketInProgress: initialState.isPurchaseTicketInProgress
      };
    case PURCHASE_TICKET_ERROR:
      return {
        ...state,
        isPurchaseTicketInProgress: initialState.isPurchaseTicketInProgress
      };

    case CLEAR_PURCHASE:
      return {
        ...state,
        ticketSelection: initialState.ticketSelection,
        purchaseInformation: initialState.purchaseInformation,
        checkout: initialState.checkout,
        isPurchaseTicketInProgress: initialState.isPurchaseTicketInProgress,
        ticketsSaleWizardState: initialState.ticketsSaleWizardState
      };

    case FETCH_PURCHASED_TICKET_LIST_START:
      return {
        ...state,
        isFetchPurchsedTicketListInProgress: true
      };
    case FETCH_PURCHASED_TICKET_LIST_SUCCESS:
      return {
        ...state,
        isFetchPurchsedTicketListInProgress: false,
        purchasedTickets: action.payload
      };
    case FETCH_PURCHASED_TICKET_LIST_ERROR:
    case CLEAR_PURCHASED_LIST:
      return {
        ...state,
        isFetchPurchsedTicketListInProgress: false,
        purchasedTickets: initialState.purchasedTickets
      };

    case FETCH_PURCHASED_TICKET_START:
      return {
        ...state,
        isFetchPurchasedTicketInProgress: true
      };
    case FETCH_PURCHASED_TICKET_SUCCESS:
      return {
        ...state,
        isFetchPurchasedTicketInProgress: false,
        purchasedTicket: action.payload
      };
    case FETCH_PURCHASED_TICKET_ERROR:
      return {
        ...state,
        isFetchPurchasedTicketInProgress: false,
        purchasedTicket: initialState.purchasedTicket
      };

    case UPDATE_PURCHASED_TICKET_START:
      return {
        ...state,
        isUpdatePurchasedTicketInProgress: true
      };
    case UPDATE_PURCHASED_TICKET_SUCCESS:
    case UPDATE_PURCHASED_TICKET_ERROR:
      return {
        ...state,
        isUpdatePurchasedTicketInProgress: false,
      };

    case ATTEND_EVENT_START:
      return {
        ...state,
        isAttendEventInProgress: true
      };
    case ATTEND_EVENT_SUCCESS:
    case ATTEND_EVENT_ERROR:
      return {
        ...state,
        isAttendEventInProgress: false
      };

    case FETCH_TICKET_RESERVE_START:
      return {
        ...state,
        isFetchTicketReserveInProgress: true
      };
    case FETCH_TICKET_RESERVE_SUCCESS:
      return {
        ...state,
        reserve: action.payload,
        isFetchTicketReserveInProgress: false
      };
    case FETCH_TICKET_RESERVE_ERROR:
      return {
        ...state,
        reserve: initialState.reserve,
        isFetchTicketReserveInProgress: false
      };

    case CREATE_TICKET_RESERVE_START:
      return {
        ...state,
        isCreateTicketReserveInProgress: true
      };
    case CREATE_TICKET_RESERVE_SUCCESS:
    case CREATE_TICKET_RESERVE_ERROR:
      return {
        ...state,
        isCreateTicketReserveInProgress: false
      };

    case CLEAR_TICKET_RESERVE:
      return {
        ...state,
        reserve: initialState.reserve
      };

    case PURCHASE_OFFLINE_TICKET_START:
      return {
        ...state,
        isPurchaseOfflineTicketInProgress: true
      };
    case PURCHASE_OFFLINE_TICKET_SUCCESS:
    case PURCHASE_OFFLINE_TICKET_ERROR:
      return {
        ...state,
        isPurchaseOfflineTicketInProgress: false
      };

    default:
      return state;
  }
}
